function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getPolyfills, promiseTimeout } from "./util.mjs";
// Config settings
var cacheSettings = {
  // Consider a fetch stale after 1 minute
  staleTTL: 1000 * 60,
  // Max time to keep a fetch in cache (4 hours default)
  maxAge: 1000 * 60 * 60 * 4,
  cacheKey: "gbFeaturesCache",
  backgroundSync: true,
  maxEntries: 10,
  disableIdleStreams: false,
  idleStreamInterval: 20000,
  disableCache: false
};
var polyfills = getPolyfills();
export var helpers = {
  fetchFeaturesCall: function fetchFeaturesCall(_ref) {
    var host = _ref.host,
      clientKey = _ref.clientKey,
      headers = _ref.headers;
    return polyfills.fetch("".concat(host, "/api/features/").concat(clientKey), {
      headers: headers
    });
  },
  fetchRemoteEvalCall: function fetchRemoteEvalCall(_ref2) {
    var host = _ref2.host,
      clientKey = _ref2.clientKey,
      payload = _ref2.payload,
      headers = _ref2.headers;
    var options = {
      method: "POST",
      headers: _objectSpread({
        "Content-Type": "application/json"
      }, headers),
      body: JSON.stringify(payload)
    };
    return polyfills.fetch("".concat(host, "/api/eval/").concat(clientKey), options);
  },
  eventSourceCall: function eventSourceCall(_ref3) {
    var host = _ref3.host,
      clientKey = _ref3.clientKey,
      headers = _ref3.headers;
    if (headers) {
      return new polyfills.EventSource("".concat(host, "/sub/").concat(clientKey), {
        headers: headers
      });
    }
    return new polyfills.EventSource("".concat(host, "/sub/").concat(clientKey));
  },
  startIdleListener: function startIdleListener() {
    var idleTimeout;
    var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
    if (!isBrowser) return;
    var onVisibilityChange = function onVisibilityChange() {
      if (document.visibilityState === "visible") {
        window.clearTimeout(idleTimeout);
        onVisible();
      } else if (document.visibilityState === "hidden") {
        idleTimeout = window.setTimeout(onHidden, cacheSettings.idleStreamInterval);
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return function () {
      return document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  },
  stopIdleListener: function stopIdleListener() {
    // No-op, replaced by startIdleListener
  }
};
try {
  if (globalThis.localStorage) {
    polyfills.localStorage = globalThis.localStorage;
  }
} catch (e) {
  // Ignore localStorage errors
}

// Global state
var subscribedInstances = new Map();
var cacheInitialized = false;
var cache = new Map();
var activeFetches = new Map();
var streams = new Map();
var supportsSSE = new Set();

// Public functions
export function setPolyfills(overrides) {
  Object.assign(polyfills, overrides);
}
export function configureCache(overrides) {
  Object.assign(cacheSettings, overrides);
  if (!cacheSettings.backgroundSync) {
    clearAutoRefresh();
  }
}
export function clearCache() {
  return _clearCache.apply(this, arguments);
}

// Get or fetch features and refresh the SDK instance
function _clearCache() {
  _clearCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          cache.clear();
          activeFetches.clear();
          clearAutoRefresh();
          cacheInitialized = false;
          _context.n = 1;
          return updatePersistentCache();
        case 1:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _clearCache.apply(this, arguments);
}
export function refreshFeatures(_x) {
  return _refreshFeatures.apply(this, arguments);
}

// Subscribe a GrowthBook instance to feature changes
function _refreshFeatures() {
  _refreshFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref4) {
    var instance, timeout, skipCache, allowStale, backgroundSync;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          instance = _ref4.instance, timeout = _ref4.timeout, skipCache = _ref4.skipCache, allowStale = _ref4.allowStale, backgroundSync = _ref4.backgroundSync;
          if (!backgroundSync) {
            cacheSettings.backgroundSync = false;
          }
          return _context2.a(2, fetchFeaturesWithCache({
            instance: instance,
            allowStale: allowStale,
            timeout: timeout,
            skipCache: skipCache
          }));
      }
    }, _callee2);
  }));
  return _refreshFeatures.apply(this, arguments);
}
function subscribe(instance) {
  var key = getKey(instance);
  var subs = subscribedInstances.get(key) || new Set();
  subs.add(instance);
  subscribedInstances.set(key, subs);
}
export function unsubscribe(instance) {
  subscribedInstances.forEach(function (s) {
    return s.delete(instance);
  });
}
export function onHidden() {
  streams.forEach(function (channel) {
    if (!channel) return;
    channel.state = "idle";
    disableChannel(channel);
  });
}
export function onVisible() {
  streams.forEach(function (channel) {
    if (!channel) return;
    if (channel.state !== "idle") return;
    enableChannel(channel);
  });
}

// Private functions
function updatePersistentCache() {
  return _updatePersistentCache.apply(this, arguments);
} // SWR wrapper for fetching features. May indirectly or directly start SSE streaming.
function _updatePersistentCache() {
  _updatePersistentCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var _t;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.p = 0;
          if (polyfills.localStorage) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2);
        case 1:
          _context3.n = 2;
          return polyfills.localStorage.setItem(cacheSettings.cacheKey, JSON.stringify(Array.from(cache.entries())));
        case 2:
          _context3.n = 4;
          break;
        case 3:
          _context3.p = 3;
          _t = _context3.v;
        case 4:
          return _context3.a(2);
      }
    }, _callee3, null, [[0, 3]]);
  }));
  return _updatePersistentCache.apply(this, arguments);
}
function fetchFeaturesWithCache(_x2) {
  return _fetchFeaturesWithCache.apply(this, arguments);
}
function _fetchFeaturesWithCache() {
  _fetchFeaturesWithCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref5) {
    var instance, allowStale, timeout, skipCache, key, cacheKey, now, minStaleAt, existing, res;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          instance = _ref5.instance, allowStale = _ref5.allowStale, timeout = _ref5.timeout, skipCache = _ref5.skipCache;
          key = getKey(instance);
          cacheKey = getCacheKey(instance);
          now = new Date();
          minStaleAt = new Date(now.getTime() - cacheSettings.maxAge + cacheSettings.staleTTL);
          _context4.n = 1;
          return initializeCache();
        case 1:
          existing = !cacheSettings.disableCache && !skipCache ? cache.get(cacheKey) : undefined;
          if (!(existing && (allowStale || existing.staleAt > now) && existing.staleAt > minStaleAt)) {
            _context4.n = 2;
            break;
          }
          // Restore from cache whether SSE is supported
          if (existing.sse) supportsSSE.add(key);

          // Reload features in the background if stale
          if (existing.staleAt < now) {
            fetchFeatures(instance);
          }
          // Otherwise, if we don't need to refresh now, start a background sync
          else {
            startAutoRefresh(instance);
          }
          return _context4.a(2, {
            data: existing.data,
            success: true,
            source: "cache"
          });
        case 2:
          _context4.n = 3;
          return promiseTimeout(fetchFeatures(instance), timeout);
        case 3:
          res = _context4.v;
          return _context4.a(2, res || {
            data: null,
            success: false,
            source: "timeout",
            error: new Error("Timeout")
          });
        case 4:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return _fetchFeaturesWithCache.apply(this, arguments);
}
function getKey(instance) {
  var _instance$getApiInfo = instance.getApiInfo(),
    _instance$getApiInfo2 = _slicedToArray(_instance$getApiInfo, 2),
    apiHost = _instance$getApiInfo2[0],
    clientKey = _instance$getApiInfo2[1];
  return "".concat(apiHost, "||").concat(clientKey);
}
function getCacheKey(instance) {
  var baseKey = getKey(instance);
  if (!("isRemoteEval" in instance) || !instance.isRemoteEval()) return baseKey;
  var attributes = instance.getAttributes();
  var cacheKeyAttributes = instance.getCacheKeyAttributes() || Object.keys(instance.getAttributes());
  var ca = {};
  cacheKeyAttributes.forEach(function (key) {
    ca[key] = attributes[key];
  });
  var fv = instance.getForcedVariations();
  var url = instance.getUrl();
  return "".concat(baseKey, "||").concat(JSON.stringify({
    ca: ca,
    fv: fv,
    url: url
  }));
}

// Populate cache from localStorage (if available)
function initializeCache() {
  return _initializeCache.apply(this, arguments);
} // Enforce the maxEntries limit
function _initializeCache() {
  _initializeCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
    var value, parsed, cleanupFn, _t2;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          if (!cacheInitialized) {
            _context5.n = 1;
            break;
          }
          return _context5.a(2);
        case 1:
          cacheInitialized = true;
          _context5.p = 2;
          if (!polyfills.localStorage) {
            _context5.n = 4;
            break;
          }
          _context5.n = 3;
          return polyfills.localStorage.getItem(cacheSettings.cacheKey);
        case 3:
          value = _context5.v;
          if (!cacheSettings.disableCache && value) {
            parsed = JSON.parse(value);
            if (parsed && Array.isArray(parsed)) {
              parsed.forEach(function (_ref6) {
                var _ref9 = _slicedToArray(_ref6, 2),
                  key = _ref9[0],
                  data = _ref9[1];
                cache.set(key, _objectSpread(_objectSpread({}, data), {}, {
                  staleAt: new Date(data.staleAt)
                }));
              });
            }
            cleanupCache();
          }
        case 4:
          _context5.n = 6;
          break;
        case 5:
          _context5.p = 5;
          _t2 = _context5.v;
        case 6:
          if (!cacheSettings.disableIdleStreams) {
            cleanupFn = helpers.startIdleListener();
            if (cleanupFn) {
              helpers.stopIdleListener = cleanupFn;
            }
          }
        case 7:
          return _context5.a(2);
      }
    }, _callee5, null, [[2, 5]]);
  }));
  return _initializeCache.apply(this, arguments);
}
function cleanupCache() {
  var entriesWithTimestamps = Array.from(cache.entries()).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      key = _ref8[0],
      value = _ref8[1];
    return {
      key: key,
      staleAt: value.staleAt.getTime()
    };
  }).sort(function (a, b) {
    return a.staleAt - b.staleAt;
  });
  var entriesToRemoveCount = Math.min(Math.max(0, cache.size - cacheSettings.maxEntries), cache.size);
  for (var i = 0; i < entriesToRemoveCount; i++) {
    cache.delete(entriesWithTimestamps[i].key);
  }
}

// Called whenever new features are fetched from the API
function onNewFeatureData(key, cacheKey, data) {
  // If contents haven't changed, ignore the update, extend the stale TTL
  var version = data.dateUpdated || "";
  var staleAt = new Date(Date.now() + cacheSettings.staleTTL);
  var existing = !cacheSettings.disableCache ? cache.get(cacheKey) : undefined;
  if (existing && version && existing.version === version) {
    existing.staleAt = staleAt;
    updatePersistentCache();
    return;
  }
  if (!cacheSettings.disableCache) {
    // Update in-memory cache
    cache.set(cacheKey, {
      data: data,
      version: version,
      staleAt: staleAt,
      sse: supportsSSE.has(key)
    });
    cleanupCache();
  }
  // Update local storage (don't await this, just update asynchronously)
  updatePersistentCache();

  // Update features for all subscribed GrowthBook instances
  var instances = subscribedInstances.get(key);
  instances && instances.forEach(function (instance) {
    return refreshInstance(instance, data);
  });
}
function refreshInstance(_x3, _x4) {
  return _refreshInstance.apply(this, arguments);
} // Fetch the features payload from helper function or from in-mem injected payload
function _refreshInstance() {
  _refreshInstance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(instance, data) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          _context6.n = 1;
          return instance.setPayload(data || instance.getPayload());
        case 1:
          return _context6.a(2);
      }
    }, _callee6);
  }));
  return _refreshInstance.apply(this, arguments);
}
function fetchFeatures(_x5) {
  return _fetchFeatures.apply(this, arguments);
} // Start SSE streaming, listens to feature payload changes and triggers a refresh or re-fetch
function _fetchFeatures() {
  _fetchFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(instance) {
    var _instance$getApiHosts2, apiHost, apiRequestHeaders, clientKey, remoteEval, key, cacheKey, promise, fetcher;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          _instance$getApiHosts2 = instance.getApiHosts(), apiHost = _instance$getApiHosts2.apiHost, apiRequestHeaders = _instance$getApiHosts2.apiRequestHeaders;
          clientKey = instance.getClientKey();
          remoteEval = "isRemoteEval" in instance && instance.isRemoteEval();
          key = getKey(instance);
          cacheKey = getCacheKey(instance);
          promise = activeFetches.get(cacheKey);
          if (!promise) {
            fetcher = remoteEval ? helpers.fetchRemoteEvalCall({
              host: apiHost,
              clientKey: clientKey,
              payload: {
                attributes: instance.getAttributes(),
                forcedVariations: instance.getForcedVariations(),
                forcedFeatures: Array.from(instance.getForcedFeatures().entries()),
                url: instance.getUrl()
              },
              headers: apiRequestHeaders
            }) : helpers.fetchFeaturesCall({
              host: apiHost,
              clientKey: clientKey,
              headers: apiRequestHeaders
            }); // TODO: auto-retry if status code indicates a temporary error
            promise = fetcher.then(function (res) {
              if (!res.ok) {
                throw new Error("HTTP error: ".concat(res.status));
              }
              if (res.headers.get("x-sse-support") === "enabled") {
                supportsSSE.add(key);
              }
              return res.json();
            }).then(function (data) {
              onNewFeatureData(key, cacheKey, data);
              startAutoRefresh(instance);
              activeFetches.delete(cacheKey);
              return {
                data: data,
                success: true,
                source: "network"
              };
            }).catch(function (e) {
              process.env.NODE_ENV !== "production" && instance.log("Error fetching features", {
                apiHost: apiHost,
                clientKey: clientKey,
                error: e ? e.message : null
              });
              activeFetches.delete(cacheKey);
              return {
                data: null,
                source: "error",
                success: false,
                error: e
              };
            });
            activeFetches.set(cacheKey, promise);
          }
          return _context7.a(2, promise);
      }
    }, _callee7);
  }));
  return _fetchFeatures.apply(this, arguments);
}
function startAutoRefresh(instance) {
  var forceSSE = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var key = getKey(instance);
  var cacheKey = getCacheKey(instance);
  var _instance$getApiHosts = instance.getApiHosts(),
    streamingHost = _instance$getApiHosts.streamingHost,
    streamingHostRequestHeaders = _instance$getApiHosts.streamingHostRequestHeaders;
  var clientKey = instance.getClientKey();
  if (forceSSE) {
    supportsSSE.add(key);
  }
  if (cacheSettings.backgroundSync && supportsSSE.has(key) && polyfills.EventSource) {
    if (streams.has(key)) return;
    var channel = {
      src: null,
      host: streamingHost,
      clientKey: clientKey,
      headers: streamingHostRequestHeaders,
      cb: function cb(event) {
        try {
          if (event.type === "features-updated") {
            var instances = subscribedInstances.get(key);
            instances && instances.forEach(function (instance) {
              fetchFeatures(instance);
            });
          } else if (event.type === "features") {
            var json = JSON.parse(event.data);
            onNewFeatureData(key, cacheKey, json);
          }
          // Reset error count on success
          channel.errors = 0;
        } catch (e) {
          process.env.NODE_ENV !== "production" && instance.log("SSE Error", {
            streamingHost: streamingHost,
            clientKey: clientKey,
            error: e ? e.message : null
          });
          onSSEError(channel);
        }
      },
      errors: 0,
      state: "active"
    };
    streams.set(key, channel);
    enableChannel(channel);
  }
}
function onSSEError(channel) {
  if (channel.state === "idle") return;
  channel.errors++;
  if (channel.errors > 3 || channel.src && channel.src.readyState === 2) {
    // exponential backoff after 4 errors, with jitter
    var delay = Math.pow(3, channel.errors - 3) * (1000 + Math.random() * 1000);
    disableChannel(channel);
    setTimeout(function () {
      if (["idle", "active"].includes(channel.state)) return;
      enableChannel(channel);
    }, Math.min(delay, 300000)); // 5 minutes max
  }
}
function disableChannel(channel) {
  if (!channel.src) return;
  channel.src.onopen = null;
  channel.src.onerror = null;
  channel.src.close();
  channel.src = null;
  if (channel.state === "active") {
    channel.state = "disabled";
  }
}
function enableChannel(channel) {
  channel.src = helpers.eventSourceCall({
    host: channel.host,
    clientKey: channel.clientKey,
    headers: channel.headers
  });
  channel.state = "active";
  channel.src.addEventListener("features", channel.cb);
  channel.src.addEventListener("features-updated", channel.cb);
  channel.src.onerror = function () {
    return onSSEError(channel);
  };
  channel.src.onopen = function () {
    channel.errors = 0;
  };
}
function destroyChannel(channel, key) {
  disableChannel(channel);
  streams.delete(key);
}
function clearAutoRefresh() {
  // Clear list of which keys are auto-updated
  supportsSSE.clear();

  // Stop listening for any SSE events
  streams.forEach(destroyChannel);

  // Remove all references to GrowthBook instances
  subscribedInstances.clear();

  // Run the idle stream cleanup function
  helpers.stopIdleListener();
}
export function startStreaming(instance, options) {
  if (options.streaming) {
    if (!instance.getClientKey()) {
      throw new Error("Must specify clientKey to enable streaming");
    }
    if (options.payload) {
      startAutoRefresh(instance, true);
    }
    subscribe(instance);
  }
}